import {
  AllotmentsExportActionTypes,
  AllotmentsExportActionUnion
} from './actions';
import { AllotmentExportState } from './state';

export const initialAllotmentsExportState: AllotmentExportState = {
  canAccessAllotments: false,
  exportGridsData: []
};

export function allotmentsExportReducer(
  state: AllotmentExportState = initialAllotmentsExportState,
  action: AllotmentsExportActionUnion
): AllotmentExportState {
  switch (action.type) {
    case AllotmentsExportActionTypes.CanAccessAllotmentsTab:
      return {
        ...state,
        canAccessAllotments: action.canAccess
      };

    case AllotmentsExportActionTypes.ExportModalOpened:
    case AllotmentsExportActionTypes.ExportModalClosed:
      return {
        ...state,
        exportGridsData: []
      };

    case AllotmentsExportActionTypes.ExportGridsDataPrepared:
      return {
        ...state,
        exportGridsData: action.exportGridsData
      };

    default:
      return state;
  }
}
